import React from 'react';
import { Center, Container, Stack } from '@fiverr-private/layout_components';
import {
    useStepper,
    Wizard,
    WizardBody,
    WizardContent,
    WizardFooter,
    WizardFooterContinueButton,
    WizardHeader,
    WizardHeaderLogo,
    WizardStepper,
} from '@fiverr-private/navigation';
import { Typography, Text } from '@fiverr-private/typography';
import { Button } from '@fiverr-private/button';
import { Image } from '@fiverr-private/media';
import { FiverrLogo, RefreshIcon } from '@fiverr-private/visuals';
import { AppI18n } from '../../i18n';
import { STEP_GROUPS_STEPPER_CONFIG } from '../../constants/stepGroups';

const ICON_URL =
    'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/ff9291bb2bf6f025490f36f86eac8e04-1749478707207/store_builder_error_icon.png';

export const ErrorPage: React.FC = () => {
    const stepperResult = useStepper({
        steps: STEP_GROUPS_STEPPER_CONFIG,
        stepStrategy: 'linear-back',
        orientation: 'horizontal',
    });

    return (
        <Wizard isOpen={true} useStepperResult={stepperResult}>
            <WizardContent>
                <WizardHeader>
                    <WizardHeaderLogo>
                        <FiverrLogo size="sm" />
                    </WizardHeaderLogo>
                    <WizardStepper />
                    <Container />
                </WizardHeader>
                <WizardBody>
                    <Center padding="12" height="100%">
                        <Stack direction="column" alignItems="center" gap="8">
                            <Image src={ICON_URL} width={120} height={78} alt="Error icon" />
                            <Stack direction="column" gap="2">
                                <Typography as="h4" fontWeight="bold" textAlign="center">
                                    <AppI18n k="error_page.title" />
                                </Typography>
                                <Text textAlign="center">
                                    <AppI18n k="error_page.description" />
                                </Text>
                            </Stack>
                            <Button onClick={() => window.location.reload()} variant="outline">
                                <RefreshIcon />
                                <AppI18n k="error_page.cta" />
                            </Button>
                        </Stack>
                    </Center>
                </WizardBody>
                <WizardFooter>
                    <WizardFooterContinueButton disabled />
                </WizardFooter>
            </WizardContent>
        </Wizard>
    );
};

ErrorPage.displayName = 'ErrorPage';
